export const notification = {
  newMessage: "新着メッセージ",
  favorite: "お気に入り登録",
  incomingCall: "着信",
  replyReceived: (args: { name: string | number }) =>
    `${args.name}さんから返信が来ています！`,
} as const;
